export const EAGER = ['@paldesk/module-federation/utils'];

const SINGLETON_ANGULAR = [
  '@angular/core',
  '@angular/common',
  '@angular/router',
  '@angular/platform-browser',
  '@angular/platform-browser-dynamic',
];

const SINGLETON_PACKAGES = [
  'zone.js',
  'rxjs',
  '@ngrx',
  '@ngx-translate/core',
  'angular-oauth2-oidc',
];

const SINGLETON_LIBS = [
  '@paldesk/module-federation/utils',
  '@paldesk/module-federation/core',
  '@paldesk/module-federation/shared',
  '@paldesk/module-federation/header',
  '@paldesk/module-federation/application-wiki-page',
  '@shared-lib/paldesk-application',
  '@features/auth',
  '@utils/interceptors',
  '@features/root-store',
  '@paldesk/cookie-consent',
];

export const SINGLETON = [
  ...SINGLETON_ANGULAR,
  ...SINGLETON_PACKAGES,
  ...SINGLETON_LIBS,
];
